import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios'; 

export const ShopContext = createContext();

const ShopContextProvider = (props) => {
    const [all_product, setAllProduct] = useState([]);
    const apiURL = process.env.REACT_APP_API_URL;

    // Fetch products from backend
    useEffect(() => {
        axios.get(apiURL + `api/products/all`, {
            headers: {
                Accept: 'application/json', 
                "ngrok-skip-browser-warning": "true"
            }
        }).then((res) => {
            setAllProduct(res.data);
        }).catch((err) => console.log(err));
    }, []);

    const getDefaultCart = () => {
        let cart = {};
        for (let index = 0; index < all_product.length; index++) {
            cart[all_product[index].id] = 0; 
        }
        return cart;
    };

    const cartList = JSON.parse(localStorage.getItem("cartList"));
    const [cartItems, setCartItems] = useState(cartList ? cartList : getDefaultCart());

    const addToCart = (itemId, quantity = 1) => {
        setCartItems((prev) => ({
            ...prev,
            [itemId]: (prev[itemId] || 0) + quantity
        }));
    };

    useEffect(() => {
        localStorage.setItem('cartList', JSON.stringify(cartItems));
        let totalItems = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                totalItems++;
                break;
            }
        }
        if(totalItems === 0) 
            localStorage.removeItem("promo")
    }, [cartItems]);

    const removeFromCart = (itemId) => {
        setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
    };

    const getPromoDiscount = () => {
        let promoDiscount = 0;
        let totalAmount = getTotalCartAmount();
        let promo = JSON.parse(localStorage.getItem("promo"));
        if(totalAmount > 0 && promo && promo.percent !== null) {
            promoDiscount = (totalAmount * promo.percent)/100;
        }
        return promoDiscount;
    }

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                let itemInfo = all_product.find((product) => product.id === Number(item));
                if (itemInfo) {
                    totalAmount += itemInfo.price * cartItems[item];
                }
            }
        }
        return totalAmount;
    };

    const getTotalCartItems = () => {
        let totalItems = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                totalItems++;
            }
        }
        return totalItems;
    };

    // Provide values to the context
    const contextValue = {
        getTotalCartItems,
        getTotalCartAmount,
        getPromoDiscount,
        all_product,
        setAllProduct,
        cartItems,
        addToCart,
        removeFromCart
    };

    return (       
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;
